import { inject, Injectable, signal, effect } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { InitDataDTO } from '../component/hornavbar/dto/InitDataDTO';
import { InitStateBackendService } from "./init-state-backed.service";

@Injectable({
  providedIn: 'root',
})
export class InitStateBusinessService {
  private initStateBackendService = inject(InitStateBackendService);

  private _currentInitData = signal<InitDataDTO>(undefined);
  private _initDataRefresher = signal<boolean | null>(null);

  // Computed signal for getting current data
  currentInitData = this._currentInitData.asReadonly();

  // Signal for observing updates
  initDataRefresher = this._initDataRefresher.asReadonly();

  constructor() {
    // Effect for automatically updating when it requires be refresher
    effect(() => {
      if (this._initDataRefresher() === true) {
        this.getInitialData(true);
        this._initDataRefresher.set(null);
      }
    });
  }

  getInitialData(forceRefresh: boolean = false): InitDataDTO {
    if (!this._currentInitData() || forceRefresh) {
      this.initStateBackendService.getInitialData()
        .pipe(tap((initData) => this._currentInitData.set(initData)))
        .subscribe();
    }
    return this._currentInitData();
  }

  refreshInitData(): void {
    this._initDataRefresher.set(true);
  }

  updateSession(): Observable<void> {
    return this.initStateBackendService.updateSession();
  }
}
